<template>
  <el-container v-title data-title="管理员列表" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
                <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form :inline="true" :model="searchForm" class="demo-form-inline" >
                <el-form-item label="姓名">
                  <el-input v-model="searchForm.realName" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="searchForm.userType" placeholder="类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="管理员" value="1" v-if="userInfo.userType === '1'"></el-option>
                    <el-option label="教职员" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="学校">
                  <el-select v-model="searchForm.schoolId" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="卡号">
                  <el-input v-model="searchForm.cardNo" placeholder="卡号"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                  <el-input v-model="searchForm.mobile" placeholder="电话"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码">
                  <el-input v-model="searchForm.idCardNo" placeholder="身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="教职管理员">
                  <el-checkbox v-model="searchForm.isFacultyAdmin">是</el-checkbox>
                </el-form-item>
                <el-form-item label="是否删除">
                  <el-select v-model="searchForm.status" placeholder="是否删除">
                    <el-option label="未删除" value="1"></el-option>
                    <el-option label="已删除" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="每页条数">
                  <el-select v-model="pageSize" @change="handleSizeChange" style="width:80px">
                    <el-option v-for="(item, index) in pageSizes" :key="index" :label="item" :value="item"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getUserList">查询</el-button>
                  <el-button type="primary" @click="openAddDialog" v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.facultyAdminAndNotAdmin">新增</el-button>
                  <el-button v-if="searchForm.schoolId != ''" type="primary" :loading="isDownloading" @click="downloadManagerList">下载</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
        <el-table v-loading="loading" :data="tableData" border stripe>
          <el-table-column prop="userName" label="用户名" width="145"></el-table-column>
          <el-table-column prop="userTypeName" label="用户类型"></el-table-column>
          <el-table-column prop="isFacultyAdminName" label="学校管理员" width="91"></el-table-column>
          <el-table-column prop="isFacultyCanteenStaffName" label="食堂员工" width="77"></el-table-column>
          <el-table-column prop="isFacultyCanteenAccountantName" label="食堂财务员" width="91"></el-table-column>
          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="schoolNames" label="学校"></el-table-column>
          <el-table-column prop="classNames" label="班级" width="120"></el-table-column>
          <el-table-column prop="allowEditClassNames" label="班主任权限" width="91"></el-table-column>
          <el-table-column prop="no" label="工号"></el-table-column>
          <el-table-column prop="mobile" label="电话" width="111"></el-table-column>
          <el-table-column prop="genderName" label="性别" width="50"></el-table-column>
          <el-table-column prop="idCardNo" label="身份证号码" width="180"></el-table-column>
          <el-table-column prop="cardNo" label="卡号" width="110"></el-table-column>
          <el-table-column prop="cardNo2" label="卡号2" width="110"></el-table-column>
          <el-table-column prop="isBindingOpenid" label="是否绑定微信" width="105"></el-table-column>
          <el-table-column prop="isHealthCodeReceiver" :formatter="isHealthCodeReceiverFormatter" label="接收健康码" width="91"></el-table-column>
          <el-table-column prop="isSalarySender" :formatter="isSalarySenderFormatter" label="发送工资条" width="91"></el-table-column>
          <el-table-column prop="facultyTypeName" label="教职员类型" width="91"></el-table-column>
          <el-table-column prop="statusName" label="状态" width="50"></el-table-column>
          <el-table-column label="人脸图片" width="100">
            <template slot-scope="scope">
              <img v-if="scope.row.meetingFacePicUrl != null && scope.row.meetingFacePicUrl.length > 0" :src="GLOBAL.picUrl + scope.row.meetingFacePicUrl" width="64" height="36" @click="openMeetingFacePicDialog(GLOBAL.picUrl + scope.row.meetingFacePicUrl)"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170">
            <template slot-scope="scope">
              <el-button type="text" @click="openModifyDialog(scope.row)" v-if="userInfo.id === scope.row.id || !scope.row.userType !== '1' && userInfo.userType === '1' || !scope.row.facultyAdminAndNotAdmin && userInfo.facultyAdminAndNotAdmin">修改</el-button>
              <el-button type="text" @click="changeStatus(scope.row)" v-if="userInfo.id === scope.row.id || !scope.row.userType !== '1' && userInfo.userType === '1' || !scope.row.facultyAdminAndNotAdmin && userInfo.facultyAdminAndNotAdmin">{{ scope.row.status == '1' ? '删除' : '恢复' }}</el-button>
              <el-button type="text" @click="openResetPasswordDialog(scope.row.id)" v-if="userInfo.id === scope.row.id || !scope.row.userType !== '1' && userInfo.userType === '1' || !scope.row.facultyAdminAndNotAdmin && userInfo.facultyAdminAndNotAdmin">重置密码</el-button>
              <el-button type="text" @click="unbindFaculty(scope.row.id)" v-if="userInfo.userType === '1' && scope.row.isBindingOpenid === '是'">解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="getUserList"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :total="total"
            layout="total,sizes,prev,pager,next" >
          </el-pagination>
        </div>
      </el-main>
      <!-- 弹窗页（修改） -->
      <el-dialog
        title="修改"
        :visible.sync="modifyDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="modifyForm" :model="modifyData" :rules="rules" label-width="90px">
          <el-form-item v-if="userInfo.userType === '1'" label="姓名" :required="true" prop="userName">
            <el-input v-model="modifyData.realName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="类型" :required="true" prop="userType">
            <el-select v-model="modifyData.userType" placeholder="请选择类型">
              <el-option label="管理员" value="1" v-if="userInfo.userType === '1'"></el-option>
              <el-option label="教职员" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId" v-if="['2'].indexOf(modifyData.userType) != -1 ? true : false">
            <el-select v-model="modifyData.schoolId" @change="getClassList(modifyData.schoolId)" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校管理员" prop="isFacultyAdmin" v-if="['2'].indexOf(modifyData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="modifyData.isFacultyAdmin" placeholder="请选择学校管理员">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" prop="classIdList" v-if="modifyData.userType == 2 ? true : false">
            <el-select v-model="modifyData.classIdList" multiple @change="genClassSubList(modifyData)">
              <el-option v-for="(item, index) in classList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班主任权限" prop="allowEditClassIdList" v-if="modifyData.userType == 2 ? true : false">
            <el-select v-model="modifyData.allowEditClassIdList" multiple>
              <el-option v-for="(item, index) in classSubList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="食堂员工" prop="isFacultyCanteenStaff" v-if="['2'].indexOf(modifyData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="modifyData.isFacultyCanteenStaff" placeholder="请选择餐厅员工">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="食堂财务员" prop="isFacultyCanteenAccountant" v-if="['2'].indexOf(modifyData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="modifyData.isFacultyCanteenAccountant" placeholder="请选择餐厅财务员">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号" prop="no">
            <el-input v-model="modifyData.no" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model="modifyData.mobile" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="modifyData.gender" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idCardNo">
            <el-input v-model="modifyData.idCardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号" prop="cardNo">
            <el-input v-model="modifyData.cardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号2" prop="cardNo2">
            <el-input v-model="modifyData.cardNo2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="接收健康码" prop="isHealthCodeReceiver" v-if="modifyData.userType == 2 ? true : false">
            <el-select v-model="modifyData.isHealthCodeReceiver" placeholder="请选择接收健康码">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送工资条" prop="isSalarySender" v-if="modifyData.userType == 2 ? true : false">
              <el-select v-model="modifyData.isSalarySender" placeholder="请选择发送工资条">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="教职员类型" prop="facultyType">
            <el-select v-model="modifyData.facultyType" placeholder="请选择教职员类型">
              <el-option label="老师" value="1"></el-option>
              <el-option label="教职工" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校2" prop="schoolId2" v-if="['2'].indexOf(modifyData.userType) != -1 ? true : false">
            <el-select v-model="modifyData.schoolId2" filterable>
              <el-option label="请选择" value=""></el-option>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="modifyUser()">修改</el-button>
            <el-button @click="modifyDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 弹窗页（新增） -->
      <el-dialog
        title="新增"
        :visible.sync="addDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="addForm" :model="addData" :rules="rules" label-width="90px">
          <!-- <el-form-item label="用户名" :required="true" prop="userName">
            <el-input v-model="addData.userName" style="width: 200px"></el-input>
          </el-form-item> -->
          <el-form-item label="姓名" :required="true" prop="realName">
            <el-input v-model="addData.realName" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="用户类型" :required="true" prop="userType">
            <el-select v-model="addData.userType" placeholder="请选择用户类型">
              <el-option label="管理员" value="1" v-if="userInfo.userType === '1'"></el-option>
              <el-option label="教职员" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" :required="true" prop="schoolId" v-if="['2'].indexOf(addData.userType) != -1 ? true : false">
            <el-select v-model="addData.schoolId" @change="getClassList(addData.schoolId)" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校管理员" prop="isFacultyAdmin" v-if="['2'].indexOf(addData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="addData.isFacultyAdmin" placeholder="请选择学校管理员">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班级" prop="classIdList" v-if="addData.userType == 2 ? true : false">
            <el-select v-model="addData.classIdList" multiple @change="genClassSubList(addData)">
              <el-option v-for="(item, index) in classList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="班主任权限" prop="allowEditClassIdList" v-if="addData.userType == 2 ? true : false">
            <el-select v-model="addData.allowEditClassIdList" multiple>
              <el-option v-for="(item, index) in classSubList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="食堂员工" prop="isFacultyCanteenStaff" v-if="['2'].indexOf(addData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="addData.isFacultyCanteenStaff" placeholder="请选择餐厅员工">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="食堂财务员" prop="isFacultyCanteenAccountant" v-if="['2'].indexOf(addData.userType) != -1 && (['1'].indexOf(userInfo.userType) != -1  || userInfo.facultyAdminAndNotAdmin) ? true : false">
            <el-select v-model="addData.isFacultyCanteenAccountant" placeholder="请选择餐厅财务员">
              <el-option label="是" value="1">是</el-option>
              <el-option label="否" value="0">否</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号" prop="no">
            <el-input v-model="addData.no" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model="addData.mobile" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-select v-model="addData.gender" placeholder="请选择性别">
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号码" prop="idCardNo">
            <el-input v-model="addData.idCardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号" prop="cardNo">
            <el-input v-model="addData.cardNo" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="卡号2" prop="cardNo2">
            <el-input v-model="addData.cardNo2" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="接收健康码" prop="isHealthCodeReceiver" v-if="modifyData.userType == 2 ? true : false">
            <el-select v-model="addData.isHealthCodeReceiver" placeholder="请选择接收健康码">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送工资条" prop="isSalarySender" v-if="modifyData.userType == 2 ? true : false">
            <el-select v-model="addData.isSalarySender" placeholder="请选择发送工资条">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="教职员类型" prop="facultyType">
            <el-select v-model="addData.facultyType" placeholder="请选择教职员类型">
              <el-option label="老师" value="1"></el-option>
              <el-option label="教职工" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校2" prop="schoolId2" v-if="['2'].indexOf(addData.userType) != -1 ? true : false">
            <el-select v-model="addData.schoolId2" filterable>
              <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addUser">新增</el-button>
            <el-button @click="addDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 重置密码 -->
      <el-dialog
        title="重置密码"
        :visible.sync="resetPasswordDialogVisible"
        width="360px"
        :before-close="handleClose">
        <el-form ref="resetPasswordForm" :model="resetPasswordData" :rules="rules" label-width="100px">
          <el-form-item label="请输入密码" :required="true" prop="password">
            <el-input v-model="resetPasswordData.password" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="请再次输入" :required="true" prop="confirmPassword">
            <el-input v-model="resetPasswordData.confirmPassword" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetPassword">重置</el-button>
            <el-button @click="resetPasswordDialogVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :visible.sync="meetingFacePicDialogVisible"
        width="800px"
        :before-close="handleClose"
        :close-on-click-modal="true">
        <img width="760" :src="picUrlOnMeetingFacePicDialog" />
      </el-dialog>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      tableData: [],
      loading: false,
      isDownloading: false,
      currentPage: 1,
      pageSize: 15,
      pageSizes: [15, 50, 100, 150, 200, 300, 500, 1000, 2000],
      total: 0,
      searchForm: {
        realName: null,
        userType: '',
        schoolId: '',
        status: '1',
        isFacultyAdmin: false
      },
      modifyData: {},
      modifyDialogVisible: false,
      addData: {
        'isFacultyAdmin': '0',
        'isFacultyCanteenStaff': '0',
        'isFacultyCanteenAccountant': '0',
        'classIdList': []
      },
      addDialogVisible: false,
      rules: {
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        userType: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
        confirmPassword: [{ required: true, message: '请确认密码', trigger: 'blur' }]
      },
      schoolList: [],
      classList: [],
      classSubList: [],
      resetPasswordData: {},
      resetPasswordDialogVisible: false,
      meetingFacePicDialogVisible: false,
      picUrlOnMeetingFacePicDialog: ''
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
      this.getUserList()
      this.getSchoolList()
    }
    console.log(this.userInfo)
  },
  created () {
    let _this = this
    document.onkeydown = function (e) {
      if (window.event.keyCode === 13) {
        _this.getUserList()
      }
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleClose (done) {
      done()
    },
    handleSizeChange (pageSize) {
      this.pageSize = pageSize
      this.getUserList()
    },
    isHealthCodeReceiverFormatter (row) {
      let isHealthCodeReceiverName = ''
      if (row.isHealthCodeReceiver === '1') {
        isHealthCodeReceiverName = '是'
      } else if (row.isHealthCodeReceiver === '0') {
        isHealthCodeReceiverName = '否'
      }
      return isHealthCodeReceiverName
    },
    isSalarySenderFormatter (row) {
      let isSalarySenderName = ''
      if (row.isSalarySender === '1') {
        isSalarySenderName = '是'
      } else if (row.isSalarySender === '0') {
        isSalarySenderName = '否'
      }
      return isSalarySenderName
    },
    getUserList (currentPage) {
      let _this = this
      _this.currentPage = typeof currentPage === 'number' ? currentPage : _this.currentPage
      let params = {
        currentUserId: _this.userInfo.id,
        filterManager: 1,
        page: _this.currentPage,
        size: _this.pageSize,
        realName: _this.searchForm.realName,
        userType: _this.searchForm.userType,
        cardNo: _this.searchForm.cardNo,
        mobile: _this.searchForm.mobile,
        idCardNo: _this.searchForm.idCardNo,
        status: _this.searchForm.status,
        schoolId: _this.searchForm.schoolId,
        isFacultyAdmin: _this.searchForm.isFacultyAdmin ? 1 : 0
      }
      _this.loading = true
      this.$axios.post(this.GLOBAL.host + '/user/list',
        this.$qs.stringify(params)
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.total = res.data.data.total
            _this.tableData = res.data.data.list
            _this.tableData.forEach(element => {
              if (element != null) {
                element.isFacultyAdmin = (element.isFacultyAdmin != null && element.isFacultyAdmin) ? '1' : '0'
                element.isFacultyCanteenStaff = (element.isFacultyCanteenStaff != null && element.isFacultyCanteenStaff) ? '1' : '0'
                element.isFacultyCanteenAccountant = (element.isFacultyCanteenAccountant != null && element.isFacultyCanteenAccountant) ? '1' : '0'
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        }
        _this.loading = false
      })
    },
    downloadManagerList () {
      if (this.searchForm.schoolId === '') return
      let _this = this
      _this.isDownloading = true
      let params = {
        currentUserId: _this.userInfo.id,
        filterManager: 1,
        realName: _this.searchForm.realName,
        userType: _this.searchForm.userType,
        cardNo: _this.searchForm.cardNo,
        mobile: _this.searchForm.mobile,
        idCardNo: _this.searchForm.idCardNo,
        status: _this.searchForm.status,
        schoolId: _this.searchForm.schoolId,
        isFacultyAdmin: _this.searchForm.isFacultyAdmin ? 1 : 0
      }
      this.$axios.post(this.GLOBAL.host + '/user/downloadManagerList',
        this.$qs.stringify(params), {
          responseType: 'blob'
        }).then(res => {
        if (res.data != null) {
          let errorMessage = ''
          let reader = new FileReader()
          reader.onload = function () {
            try {
              let response = JSON.parse(reader.result)
              if (response != null && response.message != null) {
                errorMessage = response.message
                console.log('errorMessage-111111')
                console.log('errorMessage: ' + errorMessage)
                _this.$message.error(errorMessage)
              }
            } catch (e) {
              let contentDisposition = res.headers['content-disposition']
              console.log(contentDisposition)
              let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
              let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = fileName // 重命名文件
              link.click()
              URL.revokeObjectURL(url) // 释放内存
            }
          }
          reader.readAsText(res.data)
        }
        _this.isDownloading = false
      })
    },
    openModifyDialog (userData) {
      let _this = this
      this.modifyData = JSON.parse(JSON.stringify(userData))
      this.getClassList(this.modifyData.schoolId, true, function () {
        _this.genClassSubList(_this.modifyData)
      })
      this.modifyDialogVisible = true
    },
    modifyUser () {
      let _this = this
      this.$refs['modifyForm'].validate((valid) => {
        if (valid) {
          if (_this.modifyData.schoolId != null && _this.modifyData.schoolId === _this.modifyData.schoolId2) {
            this.$message.error('学校2不可与学校相同')
            return
          }
          _this.modifyData.password = null
          _this.modifyData.isFacultyAdmin = parseInt(_this.modifyData.isFacultyAdmin)
          _this.modifyData.isFacultyCanteenStaff = parseInt(_this.modifyData.isFacultyCanteenStaff)
          _this.modifyData.isFacultyCanteenAccountant = parseInt(_this.modifyData.isFacultyCanteenAccountant)
          this.$axios.post(this.GLOBAL.host + '/user/update',
            _this.modifyData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.modifyDialogVisible = false
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                _this.getUserList()
                _this.$refs['modifyForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    openAddDialog () {
      this.addDialogVisible = true
    },
    addUser () {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (_this.modifyData.schoolId != null && _this.modifyData.schoolId === _this.modifyData.schoolId2) {
            this.$message.error('学校2不可与学校相同')
            return
          }
          _this.addData.isFacultyAdmin = parseInt(_this.addData.isFacultyAdmin)
          _this.addData.isFacultyCanteenStaff = parseInt(_this.addData.isFacultyCanteenStaff)
          _this.addData.isFacultyCanteenAccountant = parseInt(_this.addData.isFacultyCanteenAccountant)
          this.$axios.post(this.GLOBAL.host + '/user/add',
            _this.addData
          ).then(res => {
            if (res.data != null) {
              if (res.data.status === 200) {
                _this.addDialogVisible = false
                _this.addData = {
                  'classIdList': []
                }
                this.$message({
                  message: '新增成功',
                  type: 'success'
                })
                _this.getUserList()
                _this.$refs['addForm'].resetFields()
              } else {
                this.$message.error(res.data.message)
              }
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getClassList (schoolId, initFlag, callback) {
      if (schoolId === null) return
      let _this = this
      if (!initFlag) {
        _this.addData.classIdList = []
        _this.modifyData.classIdList = []
      }
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: schoolId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.classList = res.data.data.list
            callback(callback)
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    changeStatus (userInfo) {
      if (userInfo === null) return
      let _this = this
      this.$confirm('确认要' + (userInfo.status === '1' ? '删除' : '恢复') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/user/changeStatus',
          this.$qs.stringify({ userId: userInfo.id, status: userInfo.status === '1' ? '0' : '1' })
        ).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
            _this.getUserList()
          }
        })
      })
    },
    openResetPasswordDialog (userId) {
      this.resetPasswordData.userId = userId
      this.resetPasswordDialogVisible = true
    },
    resetPassword () {
      let _this = this
      this.$refs['resetPasswordForm'].validate((valid) => {
        if (valid) {
          if (_this.resetPasswordData.password !== _this.resetPasswordData.confirmPassword) {
            this.$message.error('两次输入的密码不一致')
            return
          }
          this.$confirm('确认要重置密码吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.post(this.GLOBAL.host + '/user/resetPassword',
              this.$qs.stringify({
                userId: _this.resetPasswordData.userId,
                password: _this.resetPasswordData.password
              })
            ).then(res => {
              if (res.data != null) {
                if (res.data.status === 200) {
                  this.resetPasswordDialogVisible = false
                  this.$refs['resetPasswordForm'].resetFields()
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  })
                }
              }
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    genClassSubList (formData) {
      let _this = this
      _this.classSubList = []
      let subClassIdList = []
      if (formData !== null && formData.classIdList != null && formData.classIdList.length > 0) {
        formData.classIdList.forEach(function (classId) {
          _this.classList.forEach(function (classInfo) {
            if (classInfo != null && classInfo.id === classId) {
              _this.classSubList.push(classInfo)
              subClassIdList.push(classInfo.id)
            }
          })
        })
      }
      if (formData !== null && formData.allowEditClassIdList != null && formData.allowEditClassIdList.length > 0) {
        formData.allowEditClassIdList.forEach(function (allowEditClassId, index) {
          if (subClassIdList.indexOf(allowEditClassId) < 0) {
            formData.allowEditClassIdList.splice(index, 1)
          }
        })
      }
    },
    unbindFaculty (userId) {
      let _this = this
      this.$confirm('确认要解绑教职员吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.GLOBAL.host + '/user/unbindFaculty', this.$qs.stringify({
          userId: userId
        })).then(res => {
          if (res.data != null) {
            if (res.data.status === 200) {
              this.$message.success(res.data.message)
              _this.getUserList()
            } else {
              this.$message.error(res.data.message)
            }
          }
        })
      })
    },
    openMeetingFacePicDialog (picUrl) {
      this.picUrlOnMeetingFacePicDialog = picUrl
      this.meetingFacePicDialogVisible = true
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/components/Manager.vue